var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCameraDomeOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "#"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9L3.04055 6.45683C2.85119 5.72675 3.34883 5 4.03811 5H10.8M4 9V11.381C4 15.5888 7.58172 19 12 19C15.8349 19 19.0396 16.4301 19.819 13M4 9H11.4M14 14C14 15.1 13.1 16 12 16C10.9 16 10 15.1 10 14C10 12.9 10.9 12 12 12C13.1 12 14 12.9 14 14Z",
    stroke: "black",
    strokeOpacity: 0.77,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11C20.7614 11 23 8.76142 23 6C23 3.23858 20.7614 1 18 1C15.2386 1 13 3.23858 13 6C13 8.76142 15.2386 11 18 11ZM16.5303 3.46967C16.2374 3.17678 15.7626 3.17678 15.4697 3.46967C15.1768 3.76256 15.1768 4.23744 15.4697 4.53033L16.9393 6L15.4697 7.46967C15.1768 7.76256 15.1768 8.23744 15.4697 8.53033C15.7626 8.82322 16.2374 8.82322 16.5303 8.53033L18 7.06066L19.4697 8.53033C19.7626 8.82322 20.2374 8.82322 20.5303 8.53033C20.8232 8.23744 20.8232 7.76256 20.5303 7.46967L19.0607 6L20.5303 4.53033C20.8232 4.23744 20.8232 3.76256 20.5303 3.46967C20.2374 3.17678 19.7626 3.17678 19.4697 3.46967L18 4.93934L16.5303 3.46967Z",
    fill: "#747E87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1816_3391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraDomeOffline);
export default __webpack_public_path__ + "static/media/icon-camera-dome-offline.36cc85589b15d99884f0bbaa012fbb5e.svg";
export { ForwardRef as ReactComponent };